export default Object.freeze({
  "PGE": "Transferência",
  "MAQ": "Maquininha",
  "TCC": "Antecipação solicitada no dia",
  "TCD": "Antecipação paga em datas anteriores",
});
